import { gql } from '@apollo/client';

export const ARCHIVE_EXPOSURE_TRIP = gql`
    mutation ArchiveExposureTrip($id: Int!, $supportedOrganisationId: Int!) {
        archiveExposureTrip(id: $id, supportedOrganisationId: $supportedOrganisationId) {
            id
        }
    }
`;
